import styled from 'styled-components';
import { Button as SemanticButton, Modal as SemanticModal } from 'semantic-ui-react';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: Roboto;
  min-width: 150px;
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: ${(props) => (props.weight ? props.weight : '500')};
  margin-bottom: 40px;
`;

export const ContainerError = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-top: 25px;
`;

export const Modal = styled(SemanticModal)`
  &&& {
    width: fit-content;
    padding: 40px;
    border-radius: 1px;
  }
`;

export const ModalTitle = styled.h1`
  color: #ED3A4E;
  font: "Roboto Medium";
  font-size: 16px;
`;

export const ModalMessage = styled.p`
  text-align: center;
  font-size: 14px;
  padding: 24px 0;
`;

export const ModalApprovalContainer = styled.div`
  max-height: 240px;
  min-height: 80px;
  margin-bottom: 12px;
  overflow-y: auto;
`;

export const SegmentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > h2 {
    font-size: 14px;
  }

  & + & {
    margin-top: 12px;
  }
`;

export const ApprovalWrapper = styled.div`
  display: flex;
  gap: 4px;
  
  & + & {
    margin-top: 8px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
`;

export const Button = styled(SemanticButton)`
  &&&:hover {
    color: #FFFFFF;
    background-color: #477AE9;
  }
  &&& {
    text-align: center;
    color: #FFFFFF;
    background-color: #477AE9;
    font: "Roboto Medium";
    font-size: 15px;
    font-weight: 500;
    margin: 4px;
    display: inline-flex;
  }
`;
